import onReady from 'Common/core/onReady';

export default function setupAccordionScroll() {
    onReady(() => {
        // grab all the collapsible panels in scrollable accordions
        document.querySelectorAll('.accordion.accordion--scroll .collapse').forEach((collapseEl) => {
            collapseEl.addEventListener('shown.bs.collapse', (e) => {
                // the element that was just shown
                const panel = e.currentTarget;
                // find its containing .card
                const card = panel.closest('.card');

                if (!card) return;

                // figure out how far down the card is
                const { top } = card.getBoundingClientRect();
                const scrollTarget = top + window.pageYOffset;

                // smooth-scroll the window to that position
                window.scrollTo({
                    top: scrollTarget,
                    behavior: 'smooth',
                });
            });
        });
    });
}
